export default __webpack_public_path__ + "static/media/Program1_documents_4.981ae513.jpg";